import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { api } from '@/lib/api';
import { PIN_DIALOG } from '@/constants/testIds';
import { toast } from 'sonner';

export default function PinIdeaDialog({ open, onOpenChange, inspiration, trips, onPinned }) {
    const [tripId, setTripId] = useState('');
    const [loading, setLoading] = useState(false);

    const submit = async () => {
        if (!tripId) { toast.error('Choose a trip'); return; }
        setLoading(true);
        try {
            await api.post(`/inspirations/${inspiration.inspiration_id}/pin`, { trip_id: tripId });
            toast.success(`Pinned to ${trips.find(t => t.trip_id === tripId)?.name || 'trip'}`);
            onOpenChange(false);
            onPinned?.();
        } catch (err) {
            toast.error(err?.response?.data?.detail || 'Failed to pin');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="rounded-3xl max-w-md border-[var(--ns-border)]" data-testid={PIN_DIALOG.root}>
                <DialogHeader>
                    <DialogTitle className="font-display text-2xl font-semibold tracking-tight">Pin to a trip</DialogTitle>
                    <DialogDescription className="text-[var(--ns-text2)]">
                        {inspiration ? `Add "${inspiration.location_name}" to an existing trip.` : ''}
                    </DialogDescription>
                </DialogHeader>

                <div className="mt-2">
                    {(!trips || trips.length === 0) ? (
                        <div className="rounded-2xl border border-[var(--ns-border)] bg-[var(--ns-soft)] p-4 text-sm text-[var(--ns-text2)]">
                            You don&apos;t have any active trips yet. Create one first, then pin this idea.
                        </div>
                    ) : (
                        <Select value={tripId} onValueChange={setTripId}>
                            <SelectTrigger data-testid={PIN_DIALOG.tripSelect} className="h-12 rounded-xl border-[var(--ns-border)] bg-white">
                                <SelectValue placeholder="Select a trip" />
                            </SelectTrigger>
                            <SelectContent className="rounded-2xl">
                                {trips.map((t) => (
                                    <SelectItem key={t.trip_id} value={t.trip_id}>{t.name} — {t.destination}</SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    )}
                </div>

                <DialogFooter className="mt-6">
                    <Button
                        onClick={submit}
                        disabled={loading || !trips?.length}
                        data-testid={PIN_DIALOG.submitButton}
                        className="w-full h-12 rounded-full text-white font-medium"
                        style={{ background: 'var(--ns-navy)' }}
                    >
                        {loading ? 'Pinning…' : 'Pin idea'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
